import styles from './cashBalanceWidget.module.css'
import { useMemo } from 'react'
import { CashFund, Transaction, TransactionDestinationType, TransactionSourceType } from '../../../../administration'
import { RoutePath } from '../../../../../features/routes'
import { WidgetCard } from '../widget-card/widgetCard'
import { formatAmount, isToday } from '../../../utils/dashboardUtils'

type Props = {
    loading: boolean
    error: boolean
    cashFunds: CashFund[]
    monthTransactions: Transaction[]
}

// What entered minus what left the cash funds (a transfer between cash funds adds 0)
const getNetMovement = (transactions: Transaction[]) => transactions.reduce((sum, transaction) => {
    const entered = transaction.destinationType === TransactionDestinationType.CASH_FUND ? transaction.amount : 0
    const left = transaction.sourceType === TransactionSourceType.CASH_FUND ? transaction.amount : 0
    return sum + entered - left
}, 0)

export const CashBalanceWidget = (props: Props) => {
    const { loading, error, cashFunds, monthTransactions } = props

    const { available, todayBalance, monthBalance } = useMemo(() => ({
        available: cashFunds.reduce((sum, cashFund) => sum + cashFund.availableAmount, 0),
        todayBalance: getNetMovement(monthTransactions.filter(transaction => isToday(transaction.date))),
        monthBalance: getNetMovement(monthTransactions)
    }), [cashFunds, monthTransactions])

    const balanceClass = (value: number) => value > 0 ? styles.positive : value < 0 ? styles.negative : ''
    const formatBalance = (value: number) => `${value > 0 ? '+' : ''}${formatAmount(value)}`

    return (
        <WidgetCard title="Balance de cajas" loading={loading} error={error} linkLabel="Ver cajas" linkPath={RoutePath.CASH_FUNDS}>
            <p className={styles.value}>{formatAmount(available)}</p>
            <span className={styles.label}>disponible en cajas activas</span>
            <div className={styles.balances}>
                <span>Hoy <b className={balanceClass(todayBalance)}>{formatBalance(todayBalance)}</b></span>
                <span>Mes <b className={balanceClass(monthBalance)}>{formatBalance(monthBalance)}</b></span>
            </div>
        </WidgetCard>
    )
}
